import React, {useEffect, useState} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import BenchmarksCOP from './BenchmarksCOP';
import Footer from '../miscellaneous/Footer';
import axios from 'axios';
import {useStyles, urlapi, NEED_LOGIN, types} from "../miscellaneous/constants";
import MyAppBar from '../miscellaneous/MyAppBar';
import LateralBar from "../miscellaneous/LateralBar";
import SummaryCOP from "./SummaryCOP";
import {createCOPScore} from "../miscellaneous/functionsCOP";
import {Redirect} from "react-router-dom";
import {useCookies} from "react-cookie";
import {cleanJSON} from "../miscellaneous/functions";
import Load from "../miscellaneous/Load";
import Cactus from "../graphs/Cactus";
import clsx from "clsx";
import Graphs from "../graphs/Graphs";
import {createCactusDataOptimum, createCactusDataSearch, createGraphsData} from "../graphs/createDataCOP"







export default function AnalysisCOP(props) {
    const nof = {
        optim: true,
        timeLimit: 2000,
        name: "",
        selection: "ALL",
        formula: "d > 0 && c > 0 && v > 0",
        type: "ALL",
        scoringMethod: "BEST",
        constraints: {willing: false, types: []},
        forbidfamilies: []
    }

    const [solvers, setSolvers] = useState([]);  // All solvers
    const [initialSolvers, setInitialSolvers] = useState([]);

    const [cookies, setCookie, removeCookie] = useCookies(['analyzer']);

    const [selectedSolvers, setSelectedSolvers] = useState([]); // Displayed solvers
    const [competition, setCompetition] = useState(null)        // The selected competition

    const [benchmarks, setBenchmarks] = useState([])            // Benchmarks of the competition
    const [results, setResults] = useState([]);                 // displayed results
    const [allresults, setAllresults] = useState(null)          // All results

    const [graphSolvers, setGraphSolvers] = useState(null)
    const [filters, setFilters] = useState(nof)                            // Filters
    const [nofilters, setNoFilters] = useState(nof)                        // Clear filters
    const [displayLateralBar, setDisplayLateralBar] = useState(true); // display Lateral Bar
    const [graph, setGraph] = useState(false)                    // Display graph or table data
    const [maxSolved, setMaxSolved] = useState(null)


    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);


    async function selectCompetition(id) {

        setBenchmarks([])

        let c = (await axios.get(urlapi + "/competitions/" + id)).data;
        cleanJSON(c, ["defaulttime"])
        c.rank = c.rank !== null ? JSON.parse(c.rank) : null
        setCompetition(c);
        setFilters(({...filters, timeLimit: c.defaulttime}))
        setNoFilters(({...filters, timeLimit: c.defaulttime}))
        let s = (await axios.get(urlapi + "/solversincompetition/" + c.id)).data;
        cleanJSON(s, ['id'])
        setSolvers(s);
        let b = (await axios.get(urlapi + "/benchmarksincompetition/" + c.id)).data;
        cleanJSON(b, ['competition_id', 'nb_constraints', 'nb_variables', 'optim', 'best_bound'])
        setBenchmarks(b);
        setSelectedSolvers([]);

        let max = (await axios.get(urlapi + "/competitions/maxsolved/"+c.id+"/"+c.defaulttime)).data
        setMaxSolved(max + (10 - max % 10))

        let tmp = {}
        for (let i = 0; i < s.length; i++) {
            let t = (await axios.get(urlapi + "/solverresultincompetition/" + c.id + "/" + s[i].id)).data
            cleanJSON(t, ['benchmark_id', 'best_bound', 'competition_id', 'id', 'nb_constraints', 'nb_variables', 'optim', 'solver_id', 'time'])
            for (let i = 0; i < t.length; i++)
                try {
                    t[i].bounds = JSON.parse(t[i].bounds.split("'").join('"'))
                } catch (e) {
                    //console.log(t[i].bounds, e)
                }
            tmp[s[i].id] = t
        }
        setAllresults(tmp)

        let initS = (await axios.get(urlapi + "/displaysolvers/"+c.id)).data
        setInitialSolvers(initS)

    }


    useEffect(() => {
        selectCompetition(props.match.params.id)
    }, [props.match.params.id])


    useEffect(() => {
        if (benchmarks.length === 0 || competition == null || allresults == null || solvers.length === 0 || maxSolved == null)
            return

        solversSelectionUpdate(null, initialSolvers.map(s => s.id))
    }, [props.match.params.id, benchmarks, competition, allresults, initialSolvers])





    async function selectGraphSolvers(e) {
        e.preventDefault();
        const s1 = e.target.elements[0].value
        const s2 = e.target.elements[1].value

        const solver1 = (await axios.get(urlapi + "/solver/" + s1)).data
        const solver2 = (await axios.get(urlapi + "/solver/" + s2)).data

        if (solver1.id === solver2.id)
            return
        setGraphSolvers({solver1: solver1, solver2: solver2})
    }

    function unselectGraphSolvers(e) {
        e.preventDefault()
        setGraphSolvers(null)
    }


    function toggleGraphs(e) {
        e.preventDefault()
        setGraph(!graph)
    }


    function toggleFilters(e) {
        e.preventDefault()
        setDisplayLateralBar(!displayLateralBar)
    }



    async function solversSelectionUpdate(e, ids) {
        let tmp = selectedSolvers.map(s => s);
        let tmp2 = results.map(s => s);

        if (ids.length === 0) { // unselect all
            setSelectedSolvers([])
            setResults([])
            return
        }
        let selectedSolversId = selectedSolvers.map(s => s.id)
        for (let i = 0; i < ids.length; i++) {
            let id = ids[i];
            if (solvers.length === ids.length && selectedSolversId.indexOf(id) !== -1)
                continue
            if (tmp.filter(s => s.id === id).length === 0) {
                tmp.push(solvers.filter(s => s.id === id)[0]);
                tmp2[id] = allresults[id]
            } else {
                tmp = tmp.filter(s => s.id !== id);
                tmp2[id] = undefined;
            }
        }
        setSelectedSolvers(tmp);
        setResults(tmp2);
    }

    if (NEED_LOGIN && !cookies.analyzer)
        return <Redirect to={"/login"}/>

    if (competition === null || benchmarks.length === 0 || allresults == null)
        return (
            <Load />
        )

    let constraints = {}
    for (let b of benchmarks) {
        let tmp = b.info_constraints.split("#").map(e => e.split(":")[0])
        for (let i = 1; i < tmp.length; i++) constraints[tmp[i]] = 1
    }

    let families = {}
    for (let b of benchmarks) {
        families[b.family] = 1
    }

    function createData(type) {
        if (solvers == null)
            return null
        return createGraphsData(allresults, benchmarks, filters, graphSolvers, type)
    }



    let main = null
    const scores = createCOPScore(selectedSolvers, results, benchmarks, filters)
    const opt1 = graphSolvers == null ? null : graphSolvers.solver1.name + " " + graphSolvers.solver1.version + " #Opt"
    const opt2 = graphSolvers == null ? null : graphSolvers.solver2.name + " " + graphSolvers.solver2.version + " #Opt"
    const bb1_1 = graphSolvers == null ? null : graphSolvers.solver1.name + " " + graphSolvers.solver1.version + " #BB1"
    const bb1_2 = graphSolvers == null ? null :  graphSolvers.solver2.name + " " + graphSolvers.solver2.version + " #BB1"
    const bb2_1 = graphSolvers == null ? null : graphSolvers.solver1.name + " " + graphSolvers.solver1.version + " #BB2"
    const bb2_2 = graphSolvers == null ? null :  graphSolvers.solver2.name + " " + graphSolvers.solver2.version + " #BB2"

    //createData(types.values)

    if(graph) {
        main = <Grid item xs={12}   style={{minHeight:"80vh"}}>
                <Graphs solvers={solvers}
                        selectGraphSolvers={selectGraphSolvers}
                        unselectGraphSolvers={unselectGraphSolvers}
                        filters={filters}
                        graphSolvers={graphSolvers}
                        createData={createData}
                        category1_solver1={opt1}
                        category1_solver2={opt2}
                        category2_solver1={bb1_1}
                        category2_solver2={bb1_2}
                        category3_solver1={bb2_1}
                        category3_solver2={bb2_2}
                />
        </Grid>
    } else {
        let [dataSearch, maxSearch] = createCactusDataSearch(selectedSolvers, results, benchmarks, filters)
        //maxSearch = maxSearch + (10 - maxSearch % 10)
        //maxSearch=200
         main = <Grid container spacing={3}>
            <Grid item xs={12}>
                {/* Summary */}
                <Paper className={classes.paper}>
                    <SummaryCOP scores={scores} results={results} selectedSolvers={selectedSolvers}
                                competition={props.match.params.id} benchmarks={benchmarks}
                                filters={filters}/>
                </Paper>
            </Grid>{/* All results */}
             <Grid container>
                 <Grid  item xs={12} md={12} lg={6}>
                 <Paper className={fixedHeightPaper}>
                     <Cactus title="Proof-oriented Vision" data={createCactusDataOptimum(selectedSolvers, results, benchmarks, filters)}
                             maxX={maxSolved} selectedSolvers={selectedSolvers}/>

                 </Paper>
                 </Grid>
                 <Grid  item xs={12}  md={12} lg={6}>
                     <Paper className={fixedHeightPaper}>
                         <Cactus title="Search-oriented Vision" data={dataSearch}
                                 maxX={maxSearch} selectedSolvers={selectedSolvers}/>

                     </Paper>
                 </Grid>
             </Grid>
            <Grid item xs={12}>
                <BenchmarksCOP scores={scores} results={results} selectedSolvers={selectedSolvers}
                               competition={props.match.params.id} benchmarks={benchmarks}
                               filters={filters}/>
            </Grid>
        </Grid>
    }



    let padstyle = displayLateralBar ? {paddingLeft: '240px'} : {paddingLeft: 0}


    return (
        <React.Fragment className={classes.root}>
            <CssBaseline/>
            <MyAppBar toggleFilters={toggleFilters} active={"home"} competition={competition} toggleGraph={toggleGraphs} graph={graph}/>
            <LateralBar selectedSolvers={selectedSolvers} solvers={solvers} displayLateralBar={displayLateralBar}
                        solversSelectionUpdate={solversSelectionUpdate}
                        filters={filters} setFilters={setFilters} nofilters={nofilters}
                        rank={competition.rank}
                        constraints={constraints}
                        families={families}
            />

            <main className={classes.content} style={padstyle} >
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    {main}
                    <Box pt={4}>
                        <Footer/>
                    </Box>
                </Container>
            </main>
        </React.Fragment>
    );
}
